var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 10V12V14V18V20V21C19 21.552 18.551 22 18 22H16H8H6C5.449 22 5 21.552 5 21V20V18V14V12V10V6H19V10ZM11 3C11 2.449 11.448 2 12 2C12.552 2 13 2.449 13 3V4H11V3ZM22 4H15V3C15 1.343 13.656 0 12 0C10.344 0 9 1.343 9 3V4H2C1.45 4 1 4.45 1 5C1 5.55 1.45 6 2 6H3V10V14V21C3 22.656 4.343 24 6 24H8H16H18C19.656 24 21 22.656 21 21V14V10V6H22C22.55 6 23 5.55 23 5C23 4.45 22.55 4 22 4ZM8 20C8.55 20 9 19.55 9 19V9C9 8.45 8.55 8 8 8C7.45 8 7 8.45 7 9V19C7 19.55 7.45 20 8 20ZM12 20C12.55 20 13 19.55 13 19V9C13 8.45 12.55 8 12 8C11.45 8 11 8.45 11 9V19C11 19.55 11.45 20 12 20ZM16 20C16.55 20 17 19.55 17 19V9C17 8.45 16.55 8 16 8C15.45 8 15 8.45 15 9V19C15 19.55 15.45 20 16 20Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.8987d66a73d58c4cc2188e1c5b756de7.svg";
export { ForwardRef as ReactComponent };